export default function mainFeatureCards() {
  const widgetName = 'mainFeatureCards';
  const widgetOpts = mainFeatureCardsOpts;
  const $widget = $(`#${widgetName}`);

  const $targetWidget = $('#mainSlideshow .cards-container');

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: true,
    link: ['all'],
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: false,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    moreButton: false,
    buyNowButton: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        $('.mainSlideshow-cards-container').addClass('cards-loaded');
        $targetWidget.find('.cards-container-inner').append($widget);
        createCustomCards(data.items);
      } else {
        $widget.remove();
        $targetWidget.remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      $(this).append('<span class="card-arrow"></span>');
      if (widgetData[x].URL == null) {
        $(this).removeAttr('href');
      }
    });
  }
}
